let lastMMSocketMsgTimestamp = 0;
let lastMMSocketSpecificTeamId: string | null = null;

export function recordMMSocketMessage(specificTeamId: string): void {
  lastMMSocketMsgTimestamp = Date.now();
  lastMMSocketSpecificTeamId = specificTeamId;
}

export function getLastMMSocketState(): { timestamp: number; specificTeamId: string | null } {
  return {
    timestamp: lastMMSocketMsgTimestamp,
    specificTeamId: lastMMSocketSpecificTeamId
  };
}
